import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import showcaseReducer from './reducers/';
import showcaseMiddleware, { fetchConfiguration } from './middleware/showcaseMiddleware';
import App from './components/App';
import { updateLogs, updateVastForInspect } from './actions';
import { initStateObj } from './constants/Constants';
import {
  getLocalStorage,
  setupGoogleTagManager,
  scriptSelector,
  setLocalStorage,
  decodeURLParams,
  isUrl,
} from './helpers/tools';
import $ from 'jquery';
import Samples from './components/samples/Samples';
import AppRedux from './containers/App';

setupGoogleTagManager('GTM-NRSHG4L');

//Add controller lib to page
scriptSelector();
//Set cache for calls
$.ajaxSetup({
  cache: true,
});

if (performance.navigation.type !== 1) {
  setLocalStorage('vastSource', '');
}

let initPlayerObj = initStateObj.player,
  mergedInitStateObj = Object.assign({}, initStateObj, {
    activeSection: getLocalStorage('activeSection')
      ? getLocalStorage('activeSection') - 0
      : initStateObj.activeSection,
    adData: getLocalStorage('adData') ? JSON.parse(getLocalStorage('adData')) : initStateObj.adData,
    adRules: getLocalStorage('adRules')
      ? JSON.parse(getLocalStorage('adRules'))
      : initStateObj.adRules,
    player: {
      autoplay: initPlayerObj.autoplay,
      containerId: initPlayerObj.containerId,
      name: getLocalStorage('playerName') || initPlayerObj.name,
      version: getLocalStorage('playerVersion')
        ? getLocalStorage('playerVersion')
        : initPlayerObj.version,
    },
    configuration: getLocalStorage('configuration')
      ? JSON.parse(getLocalStorage('configuration'))
      : {
          isValid: Object.assign({}, initStateObj.configuration.isValid),
          labels: Object.assign({}, initStateObj.configuration.labels),
          overlays: Object.assign({}, initStateObj.configuration.overlays),
          companions: Object.assign({}, initStateObj.configuration.companions),
          banner: Object.assign({}, initStateObj.configuration.banner),
          player: Object.assign({}, initStateObj.configuration.player),
          publisher: Object.assign({}, initStateObj.configuration.publisher),
          rtb: Object.assign({}, initStateObj.configuration.rtb),
          vpaid: Object.assign({}, initStateObj.configuration.vpaid),
        },
    other: getLocalStorage('other')
      ? JSON.parse(getLocalStorage('other'))
      : {
          isValid: Object.assign({}, initStateObj.other.isValid),
          user: Object.assign({}, initStateObj.other.user),
          content: Object.assign({}, initStateObj.other.content),
        },
    subTab: getLocalStorage('subTab') ? getLocalStorage('subTab') - 0 : initStateObj.subTab,
    vastSource: getLocalStorage('vastSource')
      ? getLocalStorage('vastSource')
      : initStateObj.vastSource,
  });

if (!mergedInitStateObj.configuration.companions) {
  mergedInitStateObj.configuration.companions = Object.assign(
    {},
    initStateObj.configuration.companions
  );
}

//Create a store and init with some values
const composeEnhancers = globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  showcaseReducer,
  mergedInitStateObj,
  composeEnhancers(applyMiddleware(showcaseMiddleware, thunkMiddleware))
);
mergedInitStateObj.logHandler = logs => {
  store.dispatch(updateLogs(logs));
};

// Get configuration from the config server
const urlParams = decodeURLParams(globalThis.location.search);
if (urlParams.psettings) {
  store.dispatch(fetchConfiguration(urlParams.psettings));
}

const vtag = urlParams.vtag;
// Get VAST Inspector value from the URL
if (vtag && isUrl(vtag)) {
  store.dispatch(updateVastForInspect(vtag));
}

//Render components
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/" exact component={AppRedux} />
        <Route path="/samples/*" component={Samples} />
        <Route component={App} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);
